// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"a9f4de16","731":"182de64b","905":"462b276d"}[chunkId] + ".chunk.js";
};